<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormCobrar" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label class="form-label" for="Observaciones">Observaciones</label>
                            <textarea :disabled="objCuentaPorCobrar.Estatus=='Pagado'" class="form-control" name="" id="" cols="30" rows="4" v-model="objCuentaPorCobrar.Observaciones"></textarea>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
export default {
    name:'FormCobrar',
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCuentaPorCobrar:{
                IdCuentaCobrar:0,
                Observaciones:'',
                FechaCobrado:'',
                NombreEmpresa:'',
                Estatus:''
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.DisableBtn=true;
            let formData=new FormData();
            formData.set('Observaciones',this.objCuentaPorCobrar.Observaciones);
            this.$http.post("/cuentaPorCobrarCobrada/"+this.objCuentaPorCobrar.IdCuentaCobrar,formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionCuentasCobrar');
        },
        EjecutaConError(err){

        },
        Recuperar(){
            this.$http.get('/cuentaPorCobrar/'+this.objCuentaPorCobrar.IdCuentaCobrar
            ).then((res)=>{
                this.objCuentaPorCobrar.Observaciones=res.data.data.Observaciones;
                this.objCuentaPorCobrar.Estatus=res.data.data.Estatus;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });

        },
        Limpiar(){
            this.objCuentaPorCobrar={
                IdCuentaCobrar:0,
                Estatus:'',
                Observaciones:'',
                FechaCobrado:'',
                NombreEmpresa:''
            },
            this.errorvalidacion=[];
        }
    },
    created() {
        this.poBtnSave.Toast=0;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCuentaPorCobrar.IdCuentaCobrar = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>

<style>

</style>